import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ToolsNavigationState {
  // Category state
  selectedCategory: string;

  // Scroll position state
  scrollPosition: number;

  // Search state
  searchQuery: string;

  // Actions
  setSelectedCategory: (category: string) => void;
  setScrollPosition: (position: number) => void;
  setSearchQuery: (query: string) => void;
  resetState: () => void;
}

const INITIAL_STATE = {
  selectedCategory: 'All',
  scrollPosition: 0,
  searchQuery: '',
};

export const useToolsNavigationStore = create<ToolsNavigationState>()(
  persist(
    (set) => ({
      ...INITIAL_STATE,

      setSelectedCategory: (category: string) =>
        set({ selectedCategory: category }),

      setScrollPosition: (position: number) =>
        set((state) => {
          // Only update if the position has changed significantly (reduces unnecessary updates)
          if (Math.abs(state.scrollPosition - position) > 10) {
            return { scrollPosition: position };
          }
          return state;
        }),

      setSearchQuery: (query: string) => set({ searchQuery: query }),

      resetState: () => set(INITIAL_STATE),
    }),
    {
      name: 'tools-navigation-state',
      // Only persist category and search, not scroll position as it's session-specific
      partialize: (state) => ({
        selectedCategory: state.selectedCategory,
        searchQuery: state.searchQuery,
      }),
    },
  ),
);
